import { render, staticRenderFns } from "./NewFeedLayout.vue?vue&type=template&id=6e6008fa&"
import script from "./NewFeedLayout.vue?vue&type=script&lang=ts&"
export * from "./NewFeedLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports